<template>
    <nav class="w-full flex flex-wrap justify-between items-center bg-torbay-primary-blue rounded-none fixed h-20">
        <div class=" w-full flex justify-between items-center py-4 px-2 md:px-4">
            <Logo></Logo>
        </div>
    </nav>
</template>
<script>
    import Logo from "./Logo.vue";
    export default {
        name: "Header",
        components: {
            Logo
        },
    };
</script>
